// extracted by mini-css-extract-plugin
module.exports = {"root":"_2nRkg","medium":"_2OvWa","large":"_3XED6","xLarge":"_3d_Ea","xxLarge":"BJoXg","xxxLarge":"Mc2_I","fill":"_3NgZL","stroke":"tBsxG"};